module.exports = __webpack_public_path__ + "static/media/adidas.dc25b46a.jpg";